export const pluginPrefix = 'PLUGIN:CFR:';
export const IS_ONLINE_RETURN = `${pluginPrefix}IS_ONLINE_RETURN`;
export const IS_CFR_RETURN = `${pluginPrefix}IS_CFR_RETURN`;
